import { HttpClient, HttpErrorResponse, HttpHeaders, } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuditTrail, BulkSecurityInfo, SecurityData, SecurityInfo, SecurityReport, UserDetails, UserInput, UserSecurityDetailCriteria, UserSecurityPreviewData } from '../models/security-model';
import { SessionExpiredService } from './session-expired-service';
import { AppConfig } from "../design/app";
import { IAppConfig } from '../core/models/app-config.model';
import { IApiResponse } from '../core/models/api-response.model';


@Injectable({
    providedIn: 'root'
})

export class SecurityService {
    appConfig:any;
    baseUrl;
    constructor(private http: HttpClient,
      private _sessionExpiredService: SessionExpiredService) {
      this.appConfig = AppConfig;
            this.baseUrl = this.appConfig.security.baseUrl;
          }

    public getSecurityData(roleid): Observable<SecurityData[]> {
        const endpoint = this.appConfig.security.GetData;
        const apiUrl = `${this.baseUrl + endpoint}`;
        const headers = new HttpHeaders();
      
        return this.http.get<IApiResponse<SecurityData[]>>(apiUrl+'?RoleId=' + roleid, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }

    public getPreview(emailids, actiontype, roleid): Observable<UserSecurityPreviewData[]> {
        const endpoint = this.appConfig.security.GetPreview;
        const apiUrl = `${this.baseUrl + endpoint}`;
        const headers = new HttpHeaders();
        const data = { "emailIdStr": emailids.toString() };
        return this.http.post<IApiResponse<UserSecurityPreviewData[]>>(apiUrl+'?actiontype=' + actiontype + '&roleId=' + roleid, data, {headers :headers}).pipe(
            map(response => {
                return response.Data;
            }),
            catchError(this.handleError)
        );
    }

    public saveDetails(bulkSecurityData : BulkSecurityInfo): Observable<string> {
        const endpoint = this.appConfig.security.SaveBulkSecurityData;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.post<IApiResponse<string>>(apiUrl, bulkSecurityData).pipe(
            map(response => {
                return response.Message;
            }),
            catchError(this.handleError)
        );
    }

    public saveCountryDetails(securityInfo: SecurityInfo): Observable<string>  {
        const endpoint = this.appConfig.security.SaveSecurityData;
        const apiUrl = `${this.baseUrl + endpoint}`;

        return this.http.post<IApiResponse<string>>(apiUrl, securityInfo).pipe(
            map(response => {
                return response.Message;
            }),
            catchError(this.handleError)
        );
    }
    
    public getEmailIdList(userInput: UserInput): Observable<UserDetails> {
        const endpoint = this.appConfig.security.GetUserListForAddingCountryAdmin;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.get<IApiResponse<UserDetails>>(apiUrl+'?UserNameOrEmail='+userInput.UserNameOrEmail).pipe(
            map(response => {
                return response.Data;
            }),
            catchError(this.handleError)
        );
    }

    public getAllUserSecurityDetailExport(userSecurityDetailCriteria: any): Observable<Uint8Array> {
        const endpoint = this.appConfig.security.ExcelReport;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.post(apiUrl, userSecurityDetailCriteria, { responseType: 'arraybuffer' }).pipe(
            map(response => {
                this._sessionExpiredService.resetTimer();
                return new Uint8Array(response);
            }),
            catchError(this.handleError)
        );
    }

    public getFacilitatorReport(contentAreaId: number): Observable<Uint8Array> {
        const endpoint = this.appConfig.security.FacilitatorReport;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.get(apiUrl+'?contentAreaId=' + contentAreaId, { responseType: 'arraybuffer' }).pipe(
            map(response => {
                this._sessionExpiredService.resetTimer();
                return new Uint8Array(response);
            }),
            catchError(this.handleError)
        );
    }

    public getExport(securityReport: SecurityReport): Observable<Uint8Array> {
        const endpoint = this.appConfig.security.GetExcelReport;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.post(apiUrl, securityReport, { responseType: 'arraybuffer' }).pipe(
            map(response => {
                this._sessionExpiredService.resetTimer();
                return new Uint8Array(response);
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };

    public getAllSecurityUsersData(criteria: UserSecurityDetailCriteria): Observable<SecurityData[]> {
        const endpoint = this.appConfig.security.users;
        const apiUrl = `${this.baseUrl + endpoint}`;
        const headers = new HttpHeaders();
        return this.http.post<IApiResponse<SecurityData[]>>(apiUrl, criteria, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }

    public getAuditTrails(userId: number): Observable<AuditTrail[]> {
        const endpoint = this.appConfig.security.audittrails;
        const apiUrl = `${this.baseUrl + endpoint}`;
        const headers = new HttpHeaders();
        return this.http.get<IApiResponse<AuditTrail[]>>(apiUrl+'?userid=' + userId, { headers: headers }).pipe(
            map(res => {
                return res.Data;
            }),
            catchError(this.handleError)
        );
    }
    public saveUserDetails(bulkSecurityData : SecurityData):Observable<string> {
        const endpoint = this.appConfig.security.save;
        const apiUrl = `${this.baseUrl + endpoint}`;
        return this.http.post<IApiResponse<string>>(apiUrl, bulkSecurityData).pipe(
            map(response => {
                return response.Data;
            }),
            catchError(this.handleError)
        );
    }
}
